import axiosInstance from "../../axiosInstance";
import type { 
  NotificationSubscriptionRequest, 
  NotificationSubscriptionResponse,
  NotificationUnsubscribeRequest,
  NotificationUnsubscribeResponse,
  ContactMessageRequest,
  ContactMessageResponse,
} from "./types";

export const notificationsService = {
  /**
   * Subscribe to event notifications
   * Authenticated users: No email required, subscription linked to user UUID
   * Non-authenticated users: Must provide email address
   */
  subscribe: async (data?: NotificationSubscriptionRequest): Promise<NotificationSubscriptionResponse> => {
    const response = await axiosInstance.post<NotificationSubscriptionResponse>(
      "/user/notification/subscribe",
      data
    );
    return response.data;
  },

  /**
   * Unsubscribe from event notifications
   * Removes an email from receiving event notifications
   */
  unsubscribe: async (data: NotificationUnsubscribeRequest): Promise<NotificationUnsubscribeResponse> => {
    const response = await axiosInstance.post<NotificationUnsubscribeResponse>(
      "/user/notification/unsubscribe",
      data
    );
    return response.data;
  },

  /**
   * Send contact message
   * Sends a message to Anchor Ingressos support team (ajuda@anchoringressos.com.br)
   * The sender's email will be set as reply-to
   */
  contact: async (data: ContactMessageRequest): Promise<ContactMessageResponse> => {
    const response = await axiosInstance.post<ContactMessageResponse>(
      "/user/notification/contact",
      data
    );
    return response.data;
  },
};
